import React from "react";
import { useNavigate } from "react-router-dom";

const HowWeWork = () => {
  const navigate = useNavigate();

  const principles = [
    {
      title: "Expert-led:",
      description: "Senior consultants with domain depth and delivery focus",
      buttonText: "How we work",
    },
    {
      title: "Human + AI:",
      description:
        "Teams augmented with AI coworkers that handle repeatable tasks",
      buttonText: "How we work",
    },
    {
      title: "Embedded by design:",
      description: "Working alongside your teams to transfer capability",
      buttonText: "How we work",
    },
  ];

  return (
    <div className="w-full py-12 lg:py-18">
      <div className="w-[88%] lg:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 lg:mb-12">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-white RoobertLight leading-[120%] mb-2">
            How we work
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-white RoobertMedium leading-[120%] mb-6">
            A modern delivery model for modern enterprise needs.
          </h3>
          <p className="text-[16px] lg:text-[18px] text-white RoobertRegular leading-[140%]">
            Our approach is shaped by three principles:
          </p>
        </div>

        {/* Principles Cards Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 mb-16 lg:mb-16">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="bg-white relative p-6 lg:p-8 flex flex-col justify-center min-h-[250px] lg:min-h-[280px] items-center"
            >
              <div className="flex-1">
                <h4 className="text-black RoobertSemiBold text-[18px] lg:text-[20px] leading-[120%] mb-4">
                  {principle.title}
                </h4>
                <p className="text-black RoobertRegular text-[16px] lg:text-[18px] leading-[140%]">
                  {principle.description}
                </p>
              </div>
              <div className="mt-6">
                <button className="bg-[#66FF00] text-black px-6 py-3 RoobertSemiBold text-[14px] lg:text-[16px] hover:bg-[#5AE600] transition-colors duration-200 w-full" onClick={() => navigate('/how-we-work')}>
                  {principle.buttonText}
                </button>
              </div>
              <div className="border-r-4 border-t-4 border-fluoro-green absolute top-0 right-0 w-1/3 h-1/3"></div>
            </div>
          ))}
        </div>

        {/* Footer Section */}
        <div className="text-center">
          <p className="text-white RoobertRegular text-[16px] lg:text-[20px] leading-[140%] mb-4 text-left">
            We bring accelerators, playbooks, and AI coworkers - but always
            adapt to your context.
          </p>
          <p className="text-white RoobertRegular text-[16px] lg:text-[20px] leading-[140%] text-left">
            From first discovery to scaled delivery, we move with your pace
          </p>
        </div>
      </div>
    </div>
  );
};

export default HowWeWork;
